<template>
  <!-- <portal-context-required-template> -->
  <div>
    <page-title />

    <!-- this is the invisible form that gets submitted when edit/add buttons get clicked. -->
    <payment-methods-form ref="form" />

    <!-- these methods control the invisible form. -->
    <payment-methods
      :on-add-payment-method="addUserPaymentMethod"
    />
  </div>
  <!-- </portal-context-required-template> -->
</template>

<script>
  import fetchable from '@mixins/fetchable';
  import PageTitle from './ManagePaymentMethods/PageTitle';
  import PaymentMethods from './ManagePaymentMethods/PaymentMethods';
  import PaymentMethodsForm from './ManagePaymentMethods/PaymentMethodsForm';
  import { onBeforeMount } from '@vue/composition-api';
  import { useGroupSelector } from '@composables/useGroupSelector';
  import { useBilling } from '@composables/useBilling';
  import { useRoute, useStore } from '@vue3shims';
  import { ref } from '@vue/composition-api';

  export default {
    mixins: [fetchable],
    components: {
      PageTitle,
      PaymentMethods,
      PaymentMethodsForm
    },
    setup() {
      const store = useStore();
      const route = useRoute();
      // const form = ref(null);
      const { 
        hasSelection, 
        // selected,
      } = useGroupSelector();
      const {
        addPaymentMethodToCybersource,
        GET_CYBERSOURCE_DETAILS,
        lobId,
      } = useBilling();
      const fetchers = [
        {
          action: 'GET_INVOICES',
          options: {
            params: {
              status: 'ALL'
            }
          },
          shouldFetch: hasSelection.value,
        },
        {
          action: 'GET_USER_PAYMENT_METHODS'
        }
      ];
      const realAddUserPaymentMethod = async () => {
        let opts = store.getters['cybersourceDetails'];
        return addPaymentMethodToCybersource(opts.url, opts);
      }
      const getCybersourceDetails = (opts) => GET_CYBERSOURCE_DETAILS(opts);

      onBeforeMount(() => {
        let dangerAlertOMG = route.query.statusCode === 'Failure'
        if (route.query.userMessage) {
          store.commit('SET_ANNOUNCEMENT', route.query.userMessage)
          if (dangerAlertOMG) { store.commit('SET_ANNOUNCEMENT_WARNING') }
        }
        console.log(`Manage Payment Methods created`, lobId.value);
      });

      return {
        fetchers,
        // form,
        getCybersourceDetails,
        hasSelection,
        lobId,
        realAddUserPaymentMethod,
      }
    },
    methods: {
      addUserPaymentMethod() {
        console.log(`addUserPaymentMethod`, this.selected, this.hasSelection, this.lobId);
        if(this.lobId !== null) {
          this.getCybersourceDetails({
            lobId: this.lobId,
            key: `lobId:${this.lobId}`,
          }).then(async () => {
            this.$refs.form.submit();
          });
        }
      }
    }
  }
</script>
